/* eslint-disable prefer-template */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
// import XLSX from 'xlsx'
import Dictionary from './dictionary';

const s2ab = (s: any) => {
  // 字符串转字符流
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) {
    // eslint-disable-next-line no-bitwise
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};

const getCharCol = (n: any) => {
  // 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
  let s = '';
  let m = 0;
  while (n > 0) {
    m = (n % 26) + 1;
    s = String.fromCharCode(m + 64) + s;
    n = (n - m) / 26;
  }
  return s;
};

/**
 * 时间戳转换为日期、时间格式
 * @param {*} timestamp
 * @param {*} time date/dateTime日期、日期时间格式
 * @returns
 */
export const transformTimestampToDate = (timestamp: any, time = 'dateTime') => {
  if (timestamp) {
    const a = new Date(Number(timestamp)).getTime();
    const date = new Date(a);
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '  ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    let dateString;
    if (time === 'date') {
      dateString = Y + M + D;
    } else {
      dateString = Y + M + D + h + m + s;
    }
    return dateString;
  } else {
    return '暂无';
  }
};

/**
  * 表格数据导出
  * @param {*} json
  * @param {*} downName
  * @param {*} type
  * @param {*} fieldNames
*/
export const downloadExl = (json: any[], downName: string, type?: any, fieldNames?: Record<any, any>) => {
  // 导出到excel
  const dictionary = fieldNames ? new Dictionary(fieldNames) : new Dictionary();
  const keyMap: any[] = []; // 获取键
  const dateFormat: any[] = []; // 记录需要修改日期的方式
  const tmpdata: any[] = []; // 用来保存转换好的json
  for (const k in json[0]) {
    if (!fieldNames && dictionary.has(k)) { // 过滤掉不需要的表头
      keyMap.push(k);
    } else {
      keyMap.push(k);
    }
  }
  // json 按行输出
  const rowData = json.map((v, i) =>
    keyMap.map((k, j) =>
      Object.assign({}, {
        v: v[k],
        position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1),
      })));
  // 分开表头和剩余数据
  const [head, ...body] = rowData;
  // 记录修改日期位置和格式, 翻译表头
  head.forEach((item, idx) => {
    if (dictionary.isDate(item.v)) {
      dateFormat[idx] = dictionary.checkDateFormat(item.v);
    }
    item.v = dictionary.getValue(item.v);
  });
  dateFormat.forEach((element, idx) => {
    if (element !== null && element) { // 非空且ture显示小时
      body.forEach((item) => {
        item[idx].v = transformTimestampToDate(item[idx].v, 'dateTime');
      });
    } else if (element !== null && !element) { // 非空且flase只显示日期
      body.forEach((item) => {
        item[idx].v = transformTimestampToDate(item[idx].v, 'date');
      });
    }
  });
  // json 从左上到右下，从左往右输出
  const sortFromLefttoRight = rowData.reduce((prev, next) => prev.concat(next));
  sortFromLefttoRight
    .forEach((v: any) => {
      tmpdata[v.position] = {
        v: v.v,
      };
    });
  const outputPos = Object.keys(tmpdata); // 设置区域,比如表格从A1到D10
  const tmpWB = {
    SheetNames: ['mySheet'], // 保存的表标题
    Sheets: {
      mySheet: Object.assign(
        {},
        tmpdata, // 内容
        {
          '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1], // 设置填充区域
        },
      ),
    },
  };
  const tmpDown: any = new Blob(
    [
      s2ab(
        // @ts-ignore CDN引入
        XLSX.write(
          tmpWB,
          {
            bookType: !type ? 'xlsx' : type,
            bookSST: false,
            type: 'binary',
          }, // 这里的数据是用来定义导出的格式类型
        ),
      ),
    ],
    {
      type: '',
    },
  ); // 创建二进制对象写入转换好的字节流
  const href = URL.createObjectURL(tmpDown); // 创建对象超链接
  const outFile = document.createElement('a');
  outFile.download = downName + '.xlsx'; // 下载名称
  outFile.style.display = 'none';
  outFile.href = href; // 绑定a标签
  document.body.appendChild(outFile);
  outFile.click(); // 模拟点击实现下载
  setTimeout(() => {
    // 延时释放
    URL.revokeObjectURL(tmpDown); // 用URL.revokeObjectURL()来释放这个object URL
    document.body.removeChild(outFile);
  }, 100);
};
